module.exports = __webpack_public_path__ + "img/Girl_010017.34f3dfd4.png";